//@flow
import { urlsConstants } from './../_constants/urls.constant';
import { defaultService } from './defaultService';

export const IntegracaoSascAtendimentosService = {
  findByFiltro,
};

function findByFiltro(options: Options, filter: any): Promise<Array<>> {
  return defaultService.findByFiltro(
    `${urlsConstants.INTEGRACAO_ATENDIMENTOS}list`,
    options,
    filter
  );
}
